import React, { useMemo } from "react";
import { Formik } from "formik";

import { Form } from "@sainsburys-tech/luna-form";
import {
  SubmitButton,
  FocusError,
  BLACK_BOX_ELEMENT_ID,
  Notification,
  NotificationStatuses,
} from "@jsainsburyplc/id-ui-common";

import validate from "./validate";
import { buildInitialValues } from "utils/registrationFormHelpers";

import { FIRST_NAME, LAST_NAME } from "constants/registrationForm";

import AccountBlockedIovation from "components/AccountBlockedIovation";
import MyAccount from "./MyAccount";
import MyDetails from "./MyDetails";
import Terms from "./Terms";
import SilentLogin from "./SilentLogin";
import MarketingPreferences from "./MarketingPreferences";

import "./styles.scss";

const RegistrationForm = ({
  onSubmit,
  regFormData,
  email,
  isIovationEnabled,
}) => {
  const { myAccount, myDetails, terms, preferences } = regFormData;

  return (
    <>
      <Formik
        initialValues={useMemo(
          () => buildInitialValues(regFormData),
          [regFormData]
        )}
        validate={validate.bind(null, { email })}
        validateOnMount={true}
        onSubmit={onSubmit}
      >
        {({ handleSubmit, values, isSubmitting, status = {}, setFieldValue }) => (
          <div>
            {status.success && (
              <SilentLogin
                username={email}
                password={values.password}
                isFromRegistration={true}
              />
            )}
            <Form onSubmit={handleSubmit} className="id-registration-form">
              {status.isBlocked && (
                <div className="ln-u-margin-bottom*2">
                  <AccountBlockedIovation />
                </div>
              )}
              {!status.success && !status.isBlocked && (
                <div>
                  <div className="c-hero c-hero--center">
                    <h1>Register your account</h1>
                  </div>
                  {status.hasError && (
                    <div className="ln-u-margin-bottom*2">
                      <Notification type={NotificationStatuses.ERROR_TYPE}>
                        {status.message}
                      </Notification>
                    </div>
                  )}
                  {myDetails && (
                    <div className="ln-u-margin-bottom*3">
                      <MyDetails myDetailsData={myDetails} userEmail={email} />
                    </div>
                  )}
                  {myAccount && (
                    <div className="ln-u-margin-bottom*3">
                      <MyAccount
                        myAccountData={myAccount}
                        userEmail={email}
                        firstName={values[FIRST_NAME]}
                        lastName={values[LAST_NAME]}
                      />
                    </div>
                  )}
                  {terms && (
                    <div className="ln-u-margin-bottom*3">
                      <Terms termsData={terms} />
                    </div>
                  )}
                  {preferences && (
                    <div className="ln-u-margin-bottom*3">
                      <MarketingPreferences
                        userEmail={email}
                        preferencesData={preferences}
                        consentAll={values.consent_all}
                        setFieldValue={setFieldValue}
                      />
                    </div>
                  )}
                  {isIovationEnabled && (
                    <input
                      type="hidden"
                      name={BLACK_BOX_ELEMENT_ID}
                      id={BLACK_BOX_ELEMENT_ID}
                      data-testid={BLACK_BOX_ELEMENT_ID}
                    />
                  )}
                  <SubmitButton
                    data-testid="continue"
                    submitHandler={handleSubmit}
                    label="Continue"
                    isLoadingLabel="Loading..."
                    isLoading={isSubmitting}
                    isOutlined
                    fullWidth
                  />
                  <FocusError />
                </div>
              )}
            </Form>
          </div>
        )}
      </Formik>
    </>
  );
};

export default RegistrationForm;
